<template>
  <el-tabs v-model="activeVertify">
    <el-tab-pane :label="$t('手机号验证')" name="phone">
      <changePsd :data="activeVertify"></changePsd>
    </el-tab-pane>
    <el-tab-pane :label="$t('邮箱验证')" name="email">
      <changePsd :data="activeVertify"></changePsd>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { ref } from "@vue/composition-api";
import changePsd from "@/components/mine/personalMessage/changePsd.vue";
export default {
  components: { changePsd },
  setup() {
    const activeVertify = ref("phone");
    return { activeVertify };
  },
};
</script>
<style scoped lang="scss"></style>